import { Fragment, useMemo, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { downloadFile } from "../../../utils/tools";

export default function PDFViewer(props) {
  const [downloading, setDownloading] = useState(false);

  const url = useMemo(() => {
    return props.link || props.location?.useProps?.fileUrl || props.fileUrl;
  }, [props]);

  async function downloadPDF() {
    if (downloading) return;
    setDownloading(true);
    const filename = url.split("/").pop().trim();
    await downloadFile(url, filename)
      .catch(console.log)
      .finally(() => setDownloading(false));
  }

  const isMobile = useMemo(() => {
    return document.body.clientWidth <= 750;
  }, []);

  return url ? (
    <Fragment>
      {/*
       */}
      {!isMobile ? (
        <div
          style={{
            width: "90%",
            height: "90%",
            margin: "auto",
            marginTop: "1rem",
            paddingTop: "1rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <iframe
            title="PDF Viewer"
            id="pdf_iframe"
            src={url}
            width="90%"
            height="800px"
          ></iframe>
        </div>
      ) : (
        <div>
          <button
            style={{
              textAlign: "center",
              padding: "5px 15px",
              borderRadius: "8px",
              fontSize: "1rem",
              border: "transparent",
              background: "rgba(92, 224, 210, 1)",
              margin: "50px auto 0 5%",
            }}
            onClick={downloadPDF}
          >
            {downloading ? "Downloading..." : "Download"}
          </button>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <div id="pdf-viewer">
              <Viewer defaultScale={1} fileUrl={url} />
            </div>
          </Worker>
        </div>
      )}
    </Fragment>
  ) : (
    <div>Loading Module...</div>
  );
}
